"use strict";

import {isset} from '../js-utilities';
import {generateValueOutput, parseInput} from './helpers/calculator-helpers';
import ManagerHelper from './helpers/manager-helper';

export default class BpManager {
    constructor(controller, language) {
        this.controller = controller;
        this.language = language;

        this.$bpSummary = $('#blood_pressure_summary');
        this.$bpSummaryValue = $('#blood_pressure_summary_value');

        this.$bpOutputCellLabel = $('#blood_pressure_output_cell_label');
        this.$bpOutputCellValue = $('#blood_pressure_output_cell_value');
        // Icon is not being used but since the functionality works I don't want to remove it, in case we use it again
        this.$bpOutputCellIcon = $('#blood_pressure_output_cell_icon');

        this.systolicHelper = new ManagerHelper('systolic_blood_pressure', this.controller, this.updateBpAgeInfluence.bind(this));
        this.diastolicHelper = new ManagerHelper('diastolic_blood_pressure', this.controller, this.updateBpAgeInfluence.bind(this));

        this.$treated = $('#treated_select');
        this.$treated.on('change', this.updateTreated.bind(this));
    }

    configureTreatedInput() {
        this.$treated.empty();

        const untreated = new Option(this.language.blood_pressure_untreated_label, 0, true);
        this.$treated.append(untreated);
        const treated = new Option(this.language.blood_pressure_treated_label, 1, false);
        this.$treated.append(treated);

        const currentValue = this.$treated.val();

        if (isset(this.controller.current_values.blood_pressure_treated)) {
            this.$treated.val(this.controller.current_values.blood_pressure_treated);
        } else {
            this.$treated.val(0);
        }

        const newValue = this.$treated.val();

        if (newValue !== currentValue) {
            this.$treated.trigger('change');
        }
    }

    updateTreated(event) {
        const inputTreated = parseInput(this.$treated.val(), 'int');

        if (event && (!isset(inputTreated) || isNaN(inputTreated))) {
            this.controller.current_values.blood_pressure_treated = 0;
            this.updateBpAgeInfluence();
            return;
        }

        if (event && (inputTreated === 0 || inputTreated === 1)) {
            this.controller.current_values.blood_pressure_treated = inputTreated;
            this.updateBpAgeInfluence();
            // this.$treated.val(inputTreated);
        } else if (this.controller.current_values.blood_pressure_treated) {
            this.$treated.val(this.controller.current_values.blood_pressure_treated);
        } else {
            this.$treated.val(0);
        }
        this.callGenerateSliderGradients();
    }


    reconfigureBpInputs() {
        if (this.systolicHelper) {
            this.systolicHelper.configureInput();
        }
        if (this.diastolicHelper) {
            this.diastolicHelper.configureInput();
        }
        this.configureTreatedInput();
    }

    callGenerateSliderGradients() {
        if (this.systolicHelper) {
            this.systolicHelper.callGenerateSliderGradient();
        }
        if (this.diastolicHelper) {
            this.diastolicHelper.callGenerateSliderGradient();
        }
    }

    // Would like to make this a generic method in the manager helper, but there's still enough deviation that this is simpler
    updateBpAgeInfluence(systolic_blood_pressure = this.controller.current_values.systolic_blood_pressure) {
        if (isset(systolic_blood_pressure) && isset(this.controller.current_values.gender)) {
            const response = this.controller.calculator_4.ageChangeForValue(this.controller.current_values.blood_pressure_treated ? 'bpt' : 'bp', systolic_blood_pressure, this.controller.current_values.fractional_age, this.controller.current_values.gender);
            this.populateBpOutput(response);
        } else {
            this.populateBpOutput();
        }
    }

    // Would like to make this a generic method in the manager helper, but there's still enough deviation that this is simpler
    populateBpOutput(response) {
        const systolicBpOutput = generateValueOutput('systolic_blood_pressure', response, this.controller);
        const diastolicBpOutput = generateValueOutput('diastolic_blood_pressure', response, this.controller);

        this.controller.current_age_changes.systolic_blood_pressure = systolicBpOutput.ageChange;
        this.controller.current_values.pressure_change = systolicBpOutput.ageChangeText

        // CAR-220 there is only one "bp" change value on age_change and current_values
        // this.controller.current_values.systolic_blood_pressure_change = systolicBpOutput.ageChangeText
        // this.controller.current_age_changes.diastolic_blood_pressure = diastolicBpOutput.ageChange;
        // this.controller.current_values.diastolic_blood_pressure_change = diastolicBpOutput.ageChangeText

        const summaryValue = `${systolicBpOutput.summaryValue}<br>${diastolicBpOutput.summaryValue}`;
        const outputCellLabel = `${systolicBpOutput.outputCellLabel}<br>${diastolicBpOutput.outputCellLabel}`;

        this.$bpSummary.html(systolicBpOutput.summary);
        this.$bpSummaryValue.html(summaryValue);

        this.$bpOutputCellLabel.html(outputCellLabel);
        this.$bpOutputCellValue.html(systolicBpOutput.outputCellValue).css('color', systolicBpOutput.outputCellColor);
        // Icon is not being used but since the functionality works I don't want to remove it, in case we use it again
        this.$bpOutputCellIcon.prop('src', systolicBpOutput.outputCellIcon);

        this.controller.calculate_vascular_age();
    }

    // public method for controller to enable and disable UI controls
    enableControls(enable) {
        this.systolicHelper.enableControls(enable);
        this.diastolicHelper.enableControls(enable);
        this.$treated.prop('disabled', !enable);
    }

}
